import { api, getCancellationToken, isCancel } from '@/core/api/';

const baseApiURL = 'api/code';

export const getDisciplineTypes = (serviceTypeId) =>
  api.get(`${baseApiURL}/disciplineTypes/${serviceTypeId}`);

export const getLocationTypes = (excludedIds) =>
  api.get(`${baseApiURL}/locationTypes`, {
    params: excludedIds
      ? [...excludedIds].map((x) => new Object({ exclude: x }))
      : [],
    paramsSerializer: (params) =>
      params.map((obj) => new URLSearchParams(obj)).join('&'),
  });

export const getDocumentTypes = (ids) =>
  api.get(`${baseApiURL}/documentTypes`, {
    params: {
      ids: ids.join(','),
    },
  });

export const getFrequencies = () => api.get(`${baseApiURL}/frequencies`);

export const getDurations = () => api.get(`${baseApiURL}/durations`);

export const getModalities = () => api.get(`${baseApiURL}/modalities`);

export const getVisitTypes = (
  day,
  month,
  year,
  contractId,
  academicYearId,
  disciplineTypeId,
  cancellationToken
) => {
  disciplineTypeId = disciplineTypeId > 0 ? disciplineTypeId : 0;
  return api
    .get(
      `${baseApiURL}/visittypes?day=${day}&month=${month}&year=${year}&contractId=${contractId}&academicYearId=${academicYearId}&disciplineTypeId=${disciplineTypeId}`,
      {
        cancelToken: cancellationToken.token,
      }
    )
    .catch((error) => {
      if (!isCancel(error)) {
        this.showErrorAlert(
          'Error al obtener los tipos de visita. Intente nuevamente.'
        );
      }
    });
};

export const getVisitAbsenceReasons = () =>
  api.get(`${baseApiURL}/visitabsencereasons`);

export const getCompensatoryApprovementReasons = (approvementOnly = false) =>
  api.get(`${baseApiURL}/compensatoryapprovementreasons/${approvementOnly}`);

export const getReevaluationTimes = () =>
  api.get(`${baseApiURL}/reevaluationtimes`);

export const getCodesByType = (payload) =>
  api.get(`${baseApiURL}/codesbytype`, {
    params: {
      ...payload,
    },
  });

export const getPeicode = (payload) =>
  api.get(`${baseApiURL}/getPeicode`, {
    params: {
      ...payload,
    },
  });
export const getApplications = () => api.get(`${baseApiURL}/application`);

export const getModules = (applicationId) =>
  api.get(`${baseApiURL}/modules/${applicationId}`);

export const CancellationToken = () => {
  return getCancellationToken();
};

export const getEligibilityStatus = () =>
  api.get(`${baseApiURL}/eligibility-status`);
